export enum ImportedProfileListTab {
  IMPORTED = "imported",
  ANALYZED = "analyzed",
  POTENTIAL = "potential",
  REJECTED = "rejected",
}

export type ImportedProfileTabCounts = {
  imported: number;
  analyzed: number;
  potential: number;
};
